import React, { useState, useEffect, useCallback } from 'react';

import { downloadFile, extractFileNameFromHeaders } from '../../../../util/DownloadUtil';

import { retrieveQueryResolutionTatReport, downloadQueryResolutionTatReport } from '../../../../services/ReportService';

import { SaveButton } from '../../../common/button/save-button/SaveButton';
import { Table } from '../../../common/table/Table';

import './QueryResolutionTAT.css';

export const QueryResolutionTAT = ({
  facility,
  dates,
  resetFilters,
  context,
  setSpinnerText,
  showToaster,
  downloadEnabled,
}) => {
  const [heading, setHeading] = useState('');
  const [results, setResults] = useState([]);

  const generateReport = useCallback(async () => {
    setSpinnerText('Generating Report');
    const [data, error] = await retrieveQueryResolutionTatReport(context.username, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      if (data.responseStatus === 'Success') {
        setHeading(data.heading);
        setResults(data.queryResolutionTaTVOS);
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  }, [context, setSpinnerText, showToaster, facility, dates]);

  useEffect(() => {
    generateReport();
  }, [generateReport]);

  const handleDownloadExcelClick = async () => {
    setSpinnerText('Downloading Query Resolution TaT Report');
    const [data, headers, error] = await downloadQueryResolutionTatReport(context.username, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      const name = extractFileNameFromHeaders(headers);
      downloadFile(data, name);
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  };

  return (
    <section className="query-resolution-tat-content">
      <div className="query-resolution-tat-table">
        <h1 className="query-resolution-tat-table-heading">{heading}</h1>
        <Table
          tableData={results}
          tableTitle="Query Resolution TAT"
          maxRowCount={7}
          hiddenColumns={[]}
          searchEnabled
          filterEnabled
          horizontalScroll
        />
      </div>
      <div className="query-resolution-tat-table-buttons">
        <SaveButton
          title="Reset Filters"
          onClick={resetFilters}
          color="white"
          textColor="#077187"
          border="1px solid #077187"
        />
        {downloadEnabled && (
          <SaveButton
            title="Download Excel"
            onClick={handleDownloadExcelClick}
            color="#077187"
            border="1px solid #077187"
          />
        )}
      </div>
    </section>
  );
};
